import { render, staticRenderFns } from "./kalemdokumanlar.vue?vue&type=template&id=7659851a"
import script from "./kalemdokumanlar.vue?vue&type=script&lang=js"
export * from "./kalemdokumanlar.vue?vue&type=script&lang=js"
import style0 from "./kalemdokumanlar.vue?vue&type=style&index=0&id=7659851a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports